import { render } from "./TasksProjects.vue?vue&type=template&id=9683b82e"
import script from "./TasksProjects.vue?vue&type=script&lang=js"
export * from "./TasksProjects.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__